module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Battleships of the World")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../style/9781473871489.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chapname1_t"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Age of Innovation 1820–1870")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Age of Experiment: 1870–1890")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Two Power Standard")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Age of the Dreadnought 1906–1908")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Naval Race 1908–1914")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 6")]), _vm._v(" Dreadnoughts at War – 1914–1918")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 7")]), _vm._v(" Pre-dreadnoughts in the First World War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 8")]), _vm._v(" The Treaty of Versailles and the Washington Naval Treaty")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 9")]), _vm._v(" Rearmament")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 10")]), _vm._v(" Battle Fleets in Action, 1939–45 – the North Sea and the Atlantic")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 11")]), _vm._v(" War in the Mediterranean")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 12")]), _vm._v(" Battleships in the Pacific")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocn"
  }, [_vm._v("Chapter 13")]), _vm._v(" The End of the Battleship Era")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74976e6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_toc.vue
// module id = 69
// module chunks = 0